import * as React from "react";
import { IncomePaymentDestination } from "../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentDestination";
import { DrawdownPaymentDestinationAllocation } from "../../../../../../Wrap/Models/Domains/Drawdown/DrawdownPaymentDestinationAllocation";
import { CheckboxGroup } from "../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { DocumentsHelper } from "../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { DocumentTaskRequestTypeEnum } from "../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { DownloadButton } from "../../../../../Shared/DownloadButton/DownloadButton";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { processTypeEnum } from "../../Common/Resource/Contents";

interface IDocumentsAndDeclarationsProps extends IProcessComponentProps {
    data: PensionContributionModel;
    customerId?: number
}

interface IDocumentsAndDeclarationsState {
    hasChecked: number[];
}

export class IncomePaymentOneOffDocumentsAndDeclarations extends ProcessComponent<IDocumentsAndDeclarationsProps, IDocumentsAndDeclarationsState> {
    constructor(props: any) {
        super(props);
        this.state = { hasChecked: [] };
    }

    public isValid(): boolean {
        let isValid = super.isValid();
        isValid = isValid && this.state.hasChecked.length == 2;
        if (!isValid) {
            this.props.showErrorMsgPopUp(["Please accept the declaration to continue"], true);
        }
        return isValid;
    }

    private getDestinationDescription(destination: DrawdownPaymentDestinationAllocation): string {
        if (destination.Destination == IncomePaymentDestination.WrapCash) {
            return "Cash Account";
        }
        const bankAccount = this.props.data.AllBankAccounts.find((x) => x.BankAccountId == destination.BankAccountId) ||
                            this.props.data.BankAccountInstructions.find((x) => x.Id == destination.BankAccountId);
        return (
            bankAccount.AccountNumber +
            " " +
            bankAccount.BankCodes.BankCode +
            "-" +
            bankAccount.BankCodes.BranchCode +
            "-" +
            bankAccount.BankCodes.ExtraCode +
            " " +
             bankAccount.AccountName
        );
    }

    private renderDeclarations() {
        return (
            <>
                <h2 className="mb-22">Declarations</h2>
                <h4 className="ml-15">Take pension benefits from crystallised account declaration</h4>
                <p className="ml-15">I can confirm that I have</p>
                <ul className="ml-15">
                    <li className="mb-15">
                    provided my client with an illustration in relation to this withdrawal, in line with my regulatory responsibilities as financial adviser, as detailed in FCA Sourcebook COBS 14.
                    </li>
                    <li className="mb-15">
                    explained to my client that any payment made will be subject to income tax deducted by Aberdeen Platform Limited and paid to HM Revenue & Customs.
                    </li>
                    <li className="mb-15">
                    explained to my client that the payment by Aberdeen Platform Limited as instructed by me discharges Aberdeen Platform Limited from all liabilities and claims in respect of benefits represented by such payment.
                    </li>
                    <li className="mb-15">
                    provided my client with the relevant guides on tax and income withdrawals.
                    </li>
                    <li className="mb-15">
                    explained to my client the cancellation rights (if any) that apply to this income payment.
                    </li>
                    <li className="mb-15">
                    that if this payment is my client’s first benefit payment, their Annual Allowance will be reduced and the Money Purchase Annual Allowance will apply, and that my client can’t carry forward any unused Annual Allowance from previous tax years.
                    </li>
                </ul>
                
                <CheckboxGroup
                    type="block"
                    wrapCss="mb-0"
                    options={[
                        {
                            label: "Confirm",
                            disabled: this.props.isReview,
                            value: this.state.hasChecked.length == 2,
                            onChange: (v) => {
                                if (v) {
                                    this.setState({ hasChecked: [1, 2] });
                                } else {
                                    this.setState({ hasChecked: [] });
                                }
                            },
                        },
                    ]}
                />
            </>
        );
    }

    private renderIncomeIllustration() {
        const clAccountId = getQueryParameters()["claccountid"];
        const clientAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
        const headAccountHierarchyId = getQueryParameters()["hierarchyid"];
        const instructionId = getQueryParameters()["id"];
        const illustrationQuery = DocumentsHelper.getTaskRequestForOneOffIncomeIllustration(
            HierarchyIdHelper.generateHierarchyId(this.props.data?.Contribution?.OneOffIncomePaymentModel?.Instruction.HierarchyId).entityId,
            clAccountId,
            DocumentTaskRequestTypeEnum.IncomeIllustration
        );
        const chargesSummaryQuery = DocumentsHelper.getTaskRequest(
            instructionId,
            this.props.customerId.toString(),
            clAccountId,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.ChargeSummary,
            processTypeEnum.OneOffIncomePayment
        )
        const config = [
            {
                title: (
                    <div className="mb-24">
                        <a className="hyperlink">Income Illustration</a>
                        <DownloadButton
                            request={illustrationQuery}
                            selectedAccount={clientAccountHierarchyId}
                        ></DownloadButton>
                    </div>
                ),
                data: " ",
            },
            {
                title: (
                    <div className="mb-24">
                        <a className="hyperlink">Charges Summary</a>
                        <DownloadButton
                            request={chargesSummaryQuery}
                            selectedAccount={clientAccountHierarchyId}
                        ></DownloadButton>
                    </div>
                ),
                data: " ",
            },
        ];
        return (
            <>
                <Typography type="wider" wrapCss="narrow-margin no-print" config={config}></Typography>
            </>
        );
    }

    render() {
        return (
            <>
                <h2 className="mb-24">Documents</h2>
                {this.renderIncomeIllustration()}                
                {this.renderDeclarations()}
            </>
        );
    }
}
